import JodiReportTable from "../../admin/JodiReport/Index";

const OperatorJodiReport = () => <JodiReportTable basePath="/operator" />;

export default OperatorJodiReport;
